module.exports = __webpack_public_path__ + "img/nudb-how-it-works.1a6923bb.png";